import { Controller } from "@hotwired/stimulus"

// Copies a payment reference and briefly confirms it on the trigger itself.
export default class extends Controller {
  static targets = ["label"]
  static values = { value: String }

  async copy(event) {
    event.preventDefault()
    let message = "Copied"
    try {
      await navigator.clipboard.writeText(this.valueValue)
    } catch {
      message = "Copy failed"
    }
    this.flash(message)
  }

  flash(message) {
    clearTimeout(this.timer)
    this.originalLabel ??= this.hasLabelTarget ? this.labelTarget.textContent : null
    this.originalAria ??= this.element.getAttribute("aria-label")
    this.originalFeedback ??= this.element.dataset.feedback ?? null
    this.element.classList.add("is-copied")
    this.element.dataset.feedback = message
    this.element.setAttribute("aria-label", message)
    if (this.hasLabelTarget) this.labelTarget.textContent = message
    this.timer = setTimeout(() => this.reset(), 1800)
  }

  reset() {
    this.element.classList.remove("is-copied")
    if (this.originalFeedback !== null) this.element.dataset.feedback = this.originalFeedback
    else delete this.element.dataset.feedback
    if (this.originalAria) this.element.setAttribute("aria-label", this.originalAria)
    if (this.hasLabelTarget && this.originalLabel !== null) this.labelTarget.textContent = this.originalLabel
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
